import { useTranslation } from 'react-i18next';
import { SupportTypeEnum } from '../../../../utils/SupportTypeEnum';
import './SupportTypeBar.scss';

const SupportTypeBar = ({ selectedSupportType, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="SupportTypeBar">
      <button
        type="button"
        className={`SupportTypeBar__item ${selectedSupportType === SupportTypeEnum.CREATOR ? 'selected' : ''}`}
        onClick={() => onChange(SupportTypeEnum.CREATOR)}
      >
        {t('Globals.supportType.creator')}
      </button>
      <button
        type="button"
        className={`SupportTypeBar__item ${selectedSupportType === SupportTypeEnum.CONSUMER ? 'selected' : ''}`}
        onClick={() => onChange(SupportTypeEnum.CONSUMER)}
      >
        {t('Globals.supportType.consumer')}
      </button>
    </div>
  );
};

export default SupportTypeBar;
